import styled from 'styled-components'

import { media } from '../../../../constants/media'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  @media ${media.medium.query} {
    justify-content: flex-start;
  }
`;

export const Tag = styled.div`
  margin: 5px;
  background-color: white;
  border-radius: 21px;
  text-align: center;

  color: ${props => props.theme.colors.nori};
  font-family: ${props => props.theme.fonts.poppins};
  font-weight: normal;
  font-size: 1.2rem;
  padding: 5px 8px;

  @media ${media.medium.query} {
    font-size: 1.6rem;
    padding: 8px 20px;
  }

  cursor: pointer;

  :hover {
    text-decoration: underline;
  }

  :first-child {
    margin-left: 0;
  }
`;